import { useVideoPlatform } from '../../hooks/useVideoPlatform';
import { VideoPlatform } from '../../video-sdk';
import { useTwilioNoiseCancellationCallbacks } from './useTwilioNoiseCancellationCallbacks';
import { useZoomNoiseCancellationCallbacks } from './useZoomNoiseCancellationCallbacks';

export enum NoiseCancellationCallbackResponseCode {
  MISSING_TRACK = 'missing_track',
  ERROR = 'error',
  NOOP = 'noop',
}

/**
 * Platform-agnostic noise cancellation callbacks.
 * Delegates to the appropriate vendor-specific hook based on the active video platform.
 */
export function useNoiseCancellationCallbacks() {
  const videoPlatformIsZoom = useVideoPlatform() === VideoPlatform.Zoom;
  const twilio = useTwilioNoiseCancellationCallbacks();
  const zoom = useZoomNoiseCancellationCallbacks();

  return videoPlatformIsZoom ? zoom : twilio;
}
